import React__default from 'react';
import { AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import clsx from 'clsx';
import DefaultIcon from '../../DefaultIcon/index.js';
import StyledFilterWrapper, { classes } from './index.styled.js';

var FilterWrapper = function (_a) {
    var className = _a.className, expandIcon = _a.expandIcon, expanded = _a.expanded, setExpanded = _a.setExpanded, filter = _a.filter, sx = _a.sx, children = _a.children, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    return (React__default.createElement(StyledFilterWrapper, { className: clsx("FilterWrapper", className), square: true, expanded: expanded, onChange: setExpanded, "data-testid": "filterButton", id: filter.label, sx: sx, disableGutters: true, elevation: 0 },
        React__default.createElement(AccordionSummary, { className: classes.summary, expandIcon: expandIcon || React__default.createElement(KIcon, { sx: { fontSize: "0.9rem" }, className: "fa-caret-down" }) },
            React__default.createElement(Typography, { variant: "body2", sx: { fontWeight: "600" } }, filter.label)),
        React__default.createElement(AccordionDetails, { className: classes.details }, children)));
};

export { FilterWrapper as default };
//# sourceMappingURL=index.js.map
